import React from 'react';
import CryptoJS from 'crypto-js';

// Helper function for AES encryption
const aesEncryptHelper = (text, key) => {
  return CryptoJS.AES.encrypt(text, key).toString();
};

// Helper function for AES decryption
const aesDecryptHelper = (cipherText, key) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};

// Helper function for Caesar cipher encryption
const caesarCipherEncrypt = (text, shift) => {
  return text.split('').map(char => {
    if (char >= 'a' && char <= 'z') {
      return String.fromCharCode(((char.charCodeAt(0) - 97 + shift) % 26) + 97);
    } else if (char >= 'A' && char <= 'Z') {
      return String.fromCharCode(((char.charCodeAt(0) - 65 + shift) % 26) + 65);
    }
    return char;
  }).join('');
};

// Helper function for Caesar cipher decryption
const caesarCipherDecrypt = (text, shift) => {
  return text.split('').map(char => {
    if (char >= 'a' && char <= 'z') {
      return String.fromCharCode(((char.charCodeAt(0) - 97 - shift + 26) % 26) + 97);
    } else if (char >= 'A' && char <= 'Z') {
      return String.fromCharCode(((char.charCodeAt(0) - 65 - shift + 26) % 26) + 65);
    }
    return char;
  }).join('');
};

const NoSecretComponent = () => {
  // AES Encryption method
  const handleAesEncrypt = (plainText = '', secretKey = '') => {
    // Ensure secretKey is a string
    const keyString = String(secretKey);
    return aesEncryptHelper(plainText, keyString);
  };

  // AES Decryption method
  const handleAesDecrypt = (cipherText = '', secretKey = '') => {
    // Ensure secretKey is a string
    const keyString = String(secretKey);
    return aesDecryptHelper(cipherText, keyString);
  };

  // Caesar Cipher Encryption method
  const handleCaesarEncrypt = (plainText = '', secretKey = '') => {
    // Ensure secretKey is a string
    const keyString = String(secretKey);
    const shift = keyString.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % 26;
    return caesarCipherEncrypt(plainText, shift);
  };

  // Caesar Cipher Decryption method
  const handleCaesarDecrypt = (cipherText = '', secretKey = '') => {
    // Ensure secretKey is a string
    const keyString = String(secretKey);
    const shift = keyString.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % 26;
    return caesarCipherDecrypt(cipherText, shift);
  };

  return {
    handleAesEncrypt,
    handleCaesarEncrypt,
    handleAesDecrypt,
    handleCaesarDecrypt
  };
};

export default NoSecretComponent;
